import React, { useState, useEffect } from 'react'
import IndividualEstimate from './individualEstimate'
import { applicationRoles } from 'application/constants/actionTypes'
import { useSelector } from 'react-redux'
import { Alert } from 'react-bootstrap'
import SpartaCustomerCount from '../estimate-compare/spartaCustomerCount'
import { ReactComponent as Flames } from '../../../images/flames.svg'
import { ReactComponent as EVBolt } from '../../../images/ev-bolt.svg'
import ContactUsDialog from '../../dialog/contactUsDialog'
import * as E from './estimateDetailElements'
import { toLowerCase, IsSpecialEmployer,fireInteractionCustomEvent, formatCurrency } from 'application/helpers'
import { SubMenuBar } from '@mmsg/louie'
import zenscroll from 'zenscroll'
import { useHistory } from 'react-router-dom'


const EstimateDetails = ({
  isConsultant,
  bannerData,
  carData,
  summaryData,
  runningData,
  financialInclusionData,
  endOfLeaseData,
  releaseData,
  isEstimateValid,
  novatedLeaseData,
}) => {
  const printClicked = (val) => {
    setPrint(val)
  }

  let history = useHistory()

  const [print, setPrint] = useState(false)
  const applicationRole = isConsultant
    ? applicationRoles.CONSULTANT
    : applicationRoles.CUSTOMER

  let isValid = isEstimateValid
  const afterMarketAccessories = useSelector(
    (state) => state.individualEstimate.afterMarketAccessories
  )

  let isEvRebate = carData.isEvRebate &&
      toLowerCase(carData.fuelType) == 'electric' &&
      toLowerCase(carData.vehicleType) == "new"
  
  let isSpartaVehicle =
    carData.vehicleId &&
    carData.shadowPR &&
    carData.spartaDetail &&
    carData.spartaDetail.offerActive

  let spartaDetail = carData.spartaDetail

  if (spartaDetail && !spartaDetail.offerActive) {
    isValid = false
  }

  let line1
  let line2
  let icon = null
  if (isSpartaVehicle) {
    line1 =
      'This car has limited availability. To increase your chances of getting it, you have to proceed before anyone else!'

    if (spartaDetail && spartaDetail.numberOfCustomerOffered > 5) {
      line2 = spartaDetail.numberOfCustomerOffered + ' others interested now'
      icon = <Flames />
    }
  } else if (isEvRebate) {
    line1 = `This electric vehicle may be eligible for a ${formatCurrency(carData.evRebateValue)} EV Bonus!`
    line2 =
      `For more information, chat to your consultant. The ${formatCurrency(carData.evRebateValue)} EV Bonus is not included in any calculations below. ` +
      ('<a href=' + carData.evRebateTnCLink +
        ' target="_blank" rel="noopener noreferrer" class="link">' +
        'Terms &amp; Conditions Apply' +
        '</a>')

    icon = <EVBolt />
  }
  const currentEstimate = useSelector(
    (state) => state.individualEstimate.selectedEstimateId
  )

  const validProposalEstimate = useSelector((state) =>
    state.proposal.proposal && state.proposal.proposal.isValid
      ? state.proposal.proposal.quoteId
      : null
  )

  let proposalMadeEstimateInvalid = false
  if (validProposalEstimate) {
    isValid = true
    if (validProposalEstimate != currentEstimate) {
      proposalMadeEstimateInvalid = true
      isValid = false
    }
  }
  const scrollZen = (about) => {
    var myDiv = document.getElementById(about)
    const rect = myDiv.getBoundingClientRect()

    const y = rect.top + window.scrollY - 50 //extra space of submenubar removed

    zenscroll.toY(y, 100)
  }
  const pdfViewClick = () => {
    zenscroll.toY(0, 500, () => {
      history.push(history.location.pathname + '/pdfview')

      fireInteractionCustomEvent({
        detail: {
          eventType: 'custom link click',
          data: {
            category: 'button',
            section: 'mylease',
            text: 'view pdf',
            label: 'view pdf',
          },
        },
      })
    })
  }

  const [offset, setOffset] = useState(0)

  useEffect(() => {
    const onScroll = () => setOffset(zenscroll.getY())
    // clean up code
    window.removeEventListener('scroll', onScroll)
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  const carDetailsY =
    document.getElementById('carDetails') &&
    zenscroll.getTopOf(document.getElementById('carDetails'))

  const summaryY =
    document.getElementById('summary') &&
    zenscroll.getTopOf(document.getElementById('summary'))

  const budgetY =
    document.getElementById('budget') &&
    zenscroll.getTopOf(document.getElementById('budget'))

  const addOnY =
    document.getElementById('addOn') &&
    zenscroll.getTopOf(document.getElementById('addOn'))

  const eolY =
    document.getElementById('eol') &&
    zenscroll.getTopOf(document.getElementById('eol'))

  const termsandconditionsY =
    document.getElementById('termsandconditions') &&
    zenscroll.getTopOf(document.getElementById('termsandconditions'))

  const submenuBarSizeConstant = 51
  return (
    <>
      <div id="page">
        <IndividualEstimate className="vehicle-estimate-page">
          <E.SubMenuContainer>
            <SubMenuBar
              background="#000"
              color="#fff"
              buttons={[
                {
                  name: 'Car Details',
                  onClick: () => {
                    scrollZen('carDetails')
                  },
                  active: offset + submenuBarSizeConstant < summaryY,
                },
                {
                  name: 'Lease Summary',
                  onClick: () => {
                    scrollZen('summary')
                  },
                  active:
                    offset + submenuBarSizeConstant >= summaryY &&
                    offset + submenuBarSizeConstant < budgetY,
                },
                {
                  name: 'Your Budget',
                  onClick: () => {
                    scrollZen('budget')
                  },
                  active:
                    offset + submenuBarSizeConstant >= budgetY &&
                    offset + submenuBarSizeConstant < addOnY,
                },
                {
                  name: 'Add-On Insurance',
                  onClick: () => {
                    scrollZen('addOn')
                  },
                  active:
                    offset + submenuBarSizeConstant >= addOnY &&
                    offset + submenuBarSizeConstant < eolY,
                },
                {
                  name: 'End-Of-Lease',
                  onClick: () => {
                    scrollZen('eol')
                  },
                  active:
                    offset + submenuBarSizeConstant >= eolY &&
                    offset + submenuBarSizeConstant < termsandconditionsY,
                },
                {
                  name: 'Important Info',
                  onClick: () => {
                    scrollZen('termsandconditions')
                  },
                  active: offset + 51 >= termsandconditionsY,
                },
              ]}
              viewPdf={{ name: 'View PDF', onClick: pdfViewClick }}
            />
          </E.SubMenuContainer>
          <IndividualEstimate.Banner
            data={bannerData}
            applicationRole={applicationRole}
            printPage={printClicked}
          />
          {((isSpartaVehicle && validProposalEstimate == null && isValid) ||
            isEvRebate) && (
            <div id="estimatedetails.infobanner">
              <SpartaCustomerCount
                line1={line1}
                line2={line2}
                extended={line2 ? false : true}
                icon={icon}
                iconTopLine={isEvRebate}
                spacingValue={line2 ? 3 : 2}
              />
            </div>
          )}
          {isValid === false && (
            <Alert
              variant="danger"
              className="section container text-left mt-4 w-100"
            >
              <E.styledAlertIcon />
              <div className="text-small ml-3 mt-3">
                <p>
                  Cannot proceed with an inactive estimate. Please{' '}
                  {applicationRole &&
                  applicationRole !== applicationRoles.CONSULTANT ? (
                    <ContactUsDialog
                      className="link"
                      theme="link"
                      launchText="contact your consultant"
                    />
                  ) : (
                    'Contact your consultant'
                  )}{' '}
                  to discuss.
                </p>
              </div>
            </Alert>
          )}

          {releaseData.isRelease && (
            <IndividualEstimate.Release {...releaseData} />
          )}

          <div id="carDetails" />
          <IndividualEstimate.Car
            data={carData}
            applicationRole={applicationRole}
            expandAccordion={print}
            afterMarketAccessories={afterMarketAccessories}
            novatedLeaseData={novatedLeaseData}
            pdfViewClick={pdfViewClick}
          />

          <div id="summary" />
          <IndividualEstimate.Summary
            data={summaryData}
            applicationRole={applicationRole}
            expandAccordion={print}
          />

          <div id="budget" />
          <IndividualEstimate.Running
            data={runningData}
            applicationRole={applicationRole}
            expandAccordion={print}
          />

          <div id="addOn" />
          <IndividualEstimate.FinancialInclusion
            data={financialInclusionData}
            applicationRole={applicationRole}
            expandAccordion={print}
          />

          <div id="eol" />
          <IndividualEstimate.EndOfLease
            data={endOfLeaseData}
            applicationRole={applicationRole}
            expandAccordion={print}
            proposalMadeEstimateInvalid={proposalMadeEstimateInvalid}
            isValid={isValid}
            pdfViewClick={pdfViewClick}
            novatedLeaseData={novatedLeaseData}
          />
        </IndividualEstimate>
      </div>
      <div id="myMm" style={{ height: '1mm' }} />
    </>
  )
}

export default EstimateDetails
